module.exports = __webpack_public_path__ + "static/media/state-props.2c8490ca.png";